// Modelo User para administrador.
export default class User {
  id=""
  login=""
  firstName=""
  lastName=""
  email=""
  identification=""
  activated=true
  authorities=[]
  clientData= {}
}



// WEBPACK FOOTER //
// ./src/model/User.js